export const environment = {
    tenantID: 'cms-qa-tj42a',
    pageName: 'W2FLY CMS',
    appFlavor: 'w2fly',
    production: false,
    appEnv: 'qa',
    googleMapsKey: 'AIzaSyBevyg2lbTYKJM-dlaxAwTqe66hZOEfYBM',
    apiConfig: {
        projectEndpoint: 'https://qa.api.w2fly.itxi.aero',
        apiKey: 'f91a7c70-df79-428e-b32a-c2cc270ce7ac',
    },
    firebase: {
        apiKey: 'AIzaSyAVKv8daFgVRfraJmstz514TLrqUGzvick',
        authDomain: 'world2fly-app.firebaseapp.com',
        databaseURL:
            'https://world2fly-app-qa.europe-west1.firebasedatabase.app',
        projectId: 'world2fly-app',
        storageBucket: 'world2fly-app-qa',
        messagingSenderId: '356789319938',
        appId: '1:356789319938:web:6c1b83370061d7d5e9ea1b',
        measurementId: 'G-DSKBD43JYY',
    },
    googleAnalyticsTrackId: '',
    rolesWithLoginAccess: [
        {
            role: 'admin',
            route: 'dashboard/content/users',
            node: 'users',
        },
        {
            role: 'power_user',
            route: 'dashboard/content/airports',
            node: 'airports',
        },
        {
            role: 'viewer',
            route: 'dashboard/content/airports',
            node: 'airports',
        },
    ],
    sessionTokenCheckInterval: 300000,
    getAllFlightsListInterval: 300000,
    sessionTokenExtension: true,
    defaultRoute: 'dashboard/content/users',
    enableRandomBackground: false,
    isGoogleAnalyticEnabled: false,
    airportCoordinates: {
        latitude: 40.4895,
        longitude: -3.5643,
        ISO3166_1_Alpha_2: 'ES',
    },
    videoCategories: [],
    userTableLanguages: [{ key: 'en', label: 'LANGUAGES.ENGLISH_ONLY' }],
    userTablesRole: [
        { key: 'admin', label: 'ROLES.ADMIN' },
        { key: 'power_user', label: 'ROLES.POWER_USER' },
        {
            key: 'viewer',
            label: 'ROLES.VIEWER',
        },
    ],
    formLanguages: [
        { key: 'en', title: 'LANGUAGES.ENGLISH', label: 'FORMS.EN_LANG' },
        { key: 'es', title: 'LANGUAGES.ESPANOL', label: 'FORMS.ES_LANG' },
        { key: 'pt', title: 'LANGUAGES.PORTUGUESE', label: 'FORMS.PT_LANG' },
    ],
    microsoftSSOClientId: 'c228bdc5-1d56-4844-a063-6e4f8e72aa02',
    googleSSOClientId:
        '356789319938-8pp9tufc8gefk75mar6pkgcccv3qfnst.apps.googleusercontent.com',
    signInOptions: ['password', 'google', 'microsoft'],
    appCategories: [],
    payment_method: [],
    payment_status: [],
    orientationArray: [],
    containerType: [],
    contentType: [],
    contentItems: [],
    equipmentType: [],
    departureTime: [],
    sectors: [],
    cartItems: [],
};
